<template>
  <div class="hero-section" :class="{ big: inLobby }">
    <div
      class="hero-bg-img h-100 d-flex align-items-end justify-content-center position-relative"
      :style="{
        background: getBackgroundImage(heroBgClass, $store.state.locale),
      }"
    >
      <template v-if="heroContentComponent"
        ><component :is="heroContentComponent"
      /></template>

      <template v-if="hasHeroNav"
        ><HeroNav :content-type="heroBgClass"
      /></template>
    </div>
  </div>
</template>
<script>
import BannerCarousel from "@/components/lobby/banner-carousel.vue";
import HeroNav from "@/components/base/hero-nav.vue";
import ProfileHeroBox from "@/components/profile/profile-hero-box.vue";
import CardsHeroBox from "@/components/cards/cards-hero-box.vue";
import ChampionsHeroBox from "@/components/champions/champions-hero-box";
import TournamentHeroBox from "./tournament/tournament-hero-box.vue";
import LeagueHeroBox from "./user-league/league-hero-box.vue";
export default {
  name: "HeroComponent",
  components: {
    ChampionsHeroBox,
    TournamentHeroBox,
    LeagueHeroBox,
    BannerCarousel,
    HeroNav,
    ProfileHeroBox,
    CardsHeroBox,
  },
  computed: {
    heroBgClass() {
      if (this.routePath === "teams") {
        return "social";
      } else if (this.routePath === "champions") {
        return "pvp";
      } else {
        return this.$route.path.split("/")[1];
      }
    },
    hasHeroNav() {
      return (
        this.$route.path.startsWith("/cards") ||
        this.$route.path.startsWith("/tournament") ||
        this.$route.path.startsWith("/profile") ||
        this.$route.path.startsWith("/league") ||
        this.$route.path.startsWith("/champions") ||
        this.$route.path.startsWith("/teams")
      );
    },

    inLobby() {
      return (
        this.$route.name === "home" ||
        this.$route.name === "home2" ||
        this.$route.name === "GameGrid" ||
        this.$route.name === "ProviderSlots"
      );
    },
    heroContentComponent() {
      if (
        this.$route.name === "home" ||
        this.$route.name === "home2" ||
        this.$route.name === "GameGrid" ||
        this.$route.name === "ProviderSlots"
      ) {
        return "BannerCarousel";
      } else if (this.$route.path.startsWith("/cards")) {
        return "CardsHeroBox";
      } else if (this.$route.path.startsWith("/tournament")) {
        return "TournamentHeroBox";
      } else if (this.$route.path.startsWith("/league")) {
        return "LeagueHeroBox";
      } else if (this.$route.path.startsWith("/profile")) {
        return "ProfileHeroBox";
      } else if (this.$route.path.startsWith("/champions")) {
        return "ChampionsHeroBox";
      } else return "";
    },
    routePath() {
      return this.$route.path.substring(1).split("/")[0];
    },
  },
  methods: {
    getBackgroundImage(heroBgClass, locale) {
      if (
        !heroBgClass ||
        heroBgClass === "games-by-provider" ||
        heroBgClass === "games"
      ) {
        return "none";
      }
      if (heroBgClass === "league") {
        const leagueLogo = this.$whitelabel.assets.features.league.logo[locale];
        const leagueHero = this.$whitelabel.assets.features.league.hero || "";

        return `url(${leagueLogo}) 50% 60% / 59.688rem 11.438rem no-repeat, 
              url(${leagueHero}) center / cover no-repeat`;
      }
      if (heroBgClass === "social") {
        const socialHero = this.$whitelabel.assets.features.social.hero;

        if (this.$whitelabel.featuresEnabled.team) {
          // if team is enabled, use the "default" image
          return `url(${socialHero.teams}) center / cover no-repeat`;
        } else {
          return `url(${
            socialHero[locale] || socialHero.default
          }) center / cover no-repeat`;
        }
      }

      const hero = this.$whitelabel.assets.features[heroBgClass].hero;
      return `url(${hero?.[locale] || hero}) center / cover no-repeat`;
    },
  },
};
</script>
<style lang="scss">
.hero-section {
  background-color: #00040f;
  margin-top: -40px;
  height: 21rem;

  &.big {
    height: 27.5rem;
  }

  .hero-content-wrapper {
    max-width: 700px;
  }
}
</style>
